// api
import { fetchApi } from '@/api'
// actions
const schoolroutesReportsAll = (context) => {
  let url = 'schoolroutes/reports'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_REPORTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesReportsForm = (context) => {
  let url = 'schoolroutes/reports/create'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_REPORTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesReportsShow = (context) => {
  let url = 'schoolroutes/reports'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_REPORTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const schoolroutesReportsCreate = (context) => {
  let url = 'schoolroutes/reports/create'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_REPORTS_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesReportsUpdate = (context) => {
  let url = 'schoolroutes/reports'
  let data = {}
  fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('SCHOOLROUTES_REPORTS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolroutesReportsDelete = (context, payload) => {
  let url = 'schoolroutes/reports'
  console.log(payload)
  fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('SCHOOLROUTES_REPORTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  schoolroutesReportsAll,
  schoolroutesReportsForm,
  schoolroutesReportsShow,
  schoolroutesReportsCreate,
  schoolroutesReportsUpdate,
  schoolroutesReportsDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/reports/actions.js